import { ColDef, ColGroupDef } from 'ag-grid-community';
import { RoundCellRenderer } from '../../../../../components/AgTable/cell-renderers/RoundCellRenderer';
import {
  PortfolioRoundIdRenderer,
  PortfolioRoundNameRenderer,
} from '../../../../../components/AgTable/cell-renderers/RoundRenderer';
import { getColorStatusMapping } from '../../../../../components/Form/ColorStatus/ColorStatus';
import { RendererType } from '../../../../../data-models/field-definition';
import { IField } from '../../../../../data-models/field2.data-model';
import { ColumnMeta } from '../../../../../types';
import { AcquisitionDataRenderer } from './TypeBasedConfigs/TypeCellRenderers/AcquisitionDataRenderer';
import { ColorStatusRenderer } from './TypeBasedConfigs/TypeCellRenderers/ColorStatusRenderer';

const colsWithAcquisitionSharesData = new Set<string>(['Ownership', 'FMV', 'NoOfShares']);

const stageRendererStyles = { fontSize: '14px' };

export function getCellRendererConfigs(
  column: ColumnMeta,
  customFieldsById: Map<number, IField<unknown>>
): Partial<ColDef | ColGroupDef> | null {
  if (column.path.includes('customData')) {
    const fieldId = Number(column.path.split('.').at(-1));
    if (!customFieldsById.has(fieldId)) {
      return null;
    }

    const customField = customFieldsById.get(fieldId);
    if (customField?.formMeta?.renderer?.type === RendererType.colorStatus) {
      const colorMapping = getColorStatusMapping();

      return {
        cellRenderer: ColorStatusRenderer,
        cellRendererParams: { colorMapping },
      };
    }
  }

  if (column.path.includes('rubricData')) {
    const colorMapping = getColorStatusMapping();

    return {
      cellRenderer: ColorStatusRenderer,
      cellRendererParams: { colorMapping },
    };
  }

  const { name, path } = column;
  if (colsWithAcquisitionSharesData.has(name)) {
    return {
      cellRenderer: AcquisitionDataRenderer,
    };
  } else if (path === 'round') {
    return {
      cellRenderer: RoundCellRenderer,
    };
  } else if (column.meta?.cellRenderer === 'stage-name-renderer') {
    return {
      cellRenderer: PortfolioRoundNameRenderer,
      cellRendererParams: { style: stageRendererStyles },
    };
  } else if (column.meta?.cellRenderer === 'stage-id-renderer') {
    return {
      cellRenderer: PortfolioRoundIdRenderer,
      cellRendererParams: { style: stageRendererStyles },
    };
  } else {
    return null;
  }
}
